export const imageUrls = [
    'https://cdn.videosdk.live/virtual-background/cloud.jpeg',
    'https://cdn.videosdk.live/virtual-background/beach.jpeg',
    'https://cdn.videosdk.live/virtual-background/san-fran.jpeg',
    'https://cdn.videosdk.live/virtual-background/paper-wall.jpeg',
];
